/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LatestTransactionsViewModel } from './LatestTransactionsViewModel';
import {
    LatestTransactionsViewModelFromJSON,
    LatestTransactionsViewModelFromJSONTyped,
    LatestTransactionsViewModelToJSON,
} from './LatestTransactionsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfLatestTransactionsViewModel
 */
export interface ResultOfLatestTransactionsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfLatestTransactionsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfLatestTransactionsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfLatestTransactionsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfLatestTransactionsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfLatestTransactionsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfLatestTransactionsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfLatestTransactionsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {LatestTransactionsViewModel}
     * @memberof ResultOfLatestTransactionsViewModel
     */
    data?: LatestTransactionsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfLatestTransactionsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfLatestTransactionsViewModel interface.
 */
export function instanceOfResultOfLatestTransactionsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfLatestTransactionsViewModelFromJSON(json: any): ResultOfLatestTransactionsViewModel {
    return ResultOfLatestTransactionsViewModelFromJSONTyped(json, false);
}

export function ResultOfLatestTransactionsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfLatestTransactionsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : LatestTransactionsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfLatestTransactionsViewModelToJSON(value?: ResultOfLatestTransactionsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': LatestTransactionsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

